module.exports = __webpack_public_path__ + "static/media/golf.dba44e8d.png";